/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Property address
 * @export
 * @interface TravelineAddressDto
 */
export interface TravelineAddressDto {
    /**
     * Postcode
     * @type {string}
     * @memberof TravelineAddressDto
     */
    postalCode?: string | null;
    /**
     * Country code.<br />
     * Compliant with ISO 3166-1 Alpha3
     * @type {string}
     * @memberof TravelineAddressDto
     */
    countryCode: string;
    /**
     * Region
     * @type {string}
     * @memberof TravelineAddressDto
     */
    region?: string | null;
    /**
     * Region ID
     * @type {string}
     * @memberof TravelineAddressDto
     */
    regionId?: string | null;
    /**
     * City name
     * @type {string}
     * @memberof TravelineAddressDto
     */
    cityName?: string | null;
    /**
     * City ID
     * @type {string}
     * @memberof TravelineAddressDto
     */
    cityId?: string | null;
    /**
     * Property address including street and house number
     * @type {string}
     * @memberof TravelineAddressDto
     */
    addressLine?: string | null;
    /**
     * Geographical latitude
     * @type {number}
     * @memberof TravelineAddressDto
     */
    latitude?: number | null;
    /**
     * Geographical longitude
     * @type {number}
     * @memberof TravelineAddressDto
     */
    longitude?: number | null;
    /**
     * (Planned) Further information on how to get there
     * @type {string}
     * @memberof TravelineAddressDto
     */
    remark?: string | null;
}

/**
 * Check if a given object implements the TravelineAddressDto interface.
 */
export function instanceOfTravelineAddressDto(value: object): value is TravelineAddressDto {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function TravelineAddressDtoFromJSON(json: any): TravelineAddressDto {
    return TravelineAddressDtoFromJSONTyped(json, false);
}

export function TravelineAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'countryCode': json['countryCode'],
        'region': json['region'] == null ? undefined : json['region'],
        'regionId': json['regionId'] == null ? undefined : json['regionId'],
        'cityName': json['cityName'] == null ? undefined : json['cityName'],
        'cityId': json['cityId'] == null ? undefined : json['cityId'],
        'addressLine': json['addressLine'] == null ? undefined : json['addressLine'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'remark': json['remark'] == null ? undefined : json['remark'],
    };
}

  export function TravelineAddressDtoToJSON(json: any): TravelineAddressDto {
      return TravelineAddressDtoToJSONTyped(json, false);
  }

  export function TravelineAddressDtoToJSONTyped(value?: TravelineAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'postalCode': value['postalCode'],
        'countryCode': value['countryCode'],
        'region': value['region'],
        'regionId': value['regionId'],
        'cityName': value['cityName'],
        'cityId': value['cityId'],
        'addressLine': value['addressLine'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'remark': value['remark'],
    };
}

